import { render } from "./ReviewsSectionCard.vue?vue&type=template&id=2d59d816&scoped=true"
import script from "./ReviewsSectionCard.vue?vue&type=script&lang=js"
export * from "./ReviewsSectionCard.vue?vue&type=script&lang=js"

import "./ReviewsSectionCard.vue?vue&type=style&index=0&id=2d59d816&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d59d816"]])

export default __exports__